import type React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Card } from '@change-corgi/design-system-legacy/components/content';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { PetitionQRCodeDownload } from 'src/app/shared/components/qrcode';
import { InfoTooltip } from 'src/app/shared/components/tooltips';

import { useDashboardReskinExperiment } from '../../../../../../hooks/useDashboardReskinExperiment';

import { FlyerDownloadLoader } from './components/FlyerDownloadLoader';
import { useShareYourPetitionOffline } from './hooks/useShareYourPetitionOffline';
import { ShareYourPetitionOfflineReskin } from './index_new';

export const ShareYourPetitionOffline: React.FC = () => {
	const {
		data: {
			shareAction: { ShareAction },
			slugOrId,
			displayType,
			downloadType,
			descriptionText,
			downloadLinkText,
			downloadFilename,
		},
	} = useShareYourPetitionOffline();

	const {
		data: { isEnabled },
	} = useDashboardReskinExperiment();

	if (isEnabled) {
		return <ShareYourPetitionOfflineReskin />;
	}

	return (
		<Card
			id="share_qrcode_module"
			data-qa="share-qrcode-module"
			data-testid="share-petition-offline-old"
			p="24px"
			backgroundColor="white"
			className="scroll-mt-20 md:scroll-mt-18"
			sx={{ border: 'unset', borderRadius: 'big' }}
		>
			<Flex sx={{ alignItems: 'center', gap: 4 }}>
				<Heading as="h3" size="h4" id="share-petition-offline-title" data-qa="share-petition-offline-title">
					<Translate value="corgi.petition.starter_dashboard.grow_petition.share_petition_offline.title" />
				</Heading>
				<InfoTooltip aria-describedby="share-petition-offline-title">
					<Translate value="corgi.petition.starter_dashboard.grow_petition.share_petition_offline.tooltip" />
				</InfoTooltip>
			</Flex>
			<Flex mt={16} sx={{ gap: '16' }}>
				<ShareAction>
					<PetitionQRCodeDownload
						slugOrId={slugOrId}
						displaySize={100}
						displayType={displayType}
						downloadType={downloadType}
						descriptionText={descriptionText}
						downloadLinkText={downloadLinkText}
						downloadFilename={downloadFilename}
					/>
				</ShareAction>
			</Flex>
			<FlyerDownloadLoader />
		</Card>
	);
};
